import PropTypes from 'prop-types';
import React from 'react';
import { filterPrice } from '../../brands/default/config';
import { FILTER_PRICE } from '../../brands/default/content/components/filters';
import { getCountryCurrency } from '../../helpers/currency';
import RangeSelector from '../_generic/range/RangeSelectorDynamic';

export const PriceRange = ({
  filterPrices = filterPrice,
  invert,
  inline,
  updateFilter,
  categories,
  sortBy,
  sliderValues,
  vipSearchFilter,
}) => {
  const currency = getCountryCurrency();

  return (
    <RangeSelector
      inline={inline}
      invert={invert}
      label={FILTER_PRICE}
      marks={filterPrices.reduce((out, item, index) => {
        out[index] = {
          label: '##currency####price##'
            .replace('##currency##', currency)
            .replace('##price##', item.name),
        };
        if (index === filterPrices.length - 1) {
          out[index].label += '+';
        }

        return out;
      }, {})}
      max={filterPrices.length - 1}
      min={0}
      onChange={(value) => {
        updateFilter({
          categories,
          sliderValues: value,
          sortBy,
          vipSearchFilter,
        });
      }}
      onReset={() => {
        updateFilter({
          categories,
          sliderValues: [0, filterPrices.length - 1],
          sortBy,
          vipSearchFilter: false,
        });
      }}
      value={sliderValues}
    />
  );
};

PriceRange.propTypes = {
  categories: PropTypes.array.isRequired,
  filterPrices: PropTypes.array,
  inline: PropTypes.bool.isRequired,
  invert: PropTypes.bool.isRequired,
  sliderValues: PropTypes.array.isRequired,
  sortBy: PropTypes.string.isRequired,
  updateFilter: PropTypes.func.isRequired,
  vipSearchFilter: PropTypes.bool,
};
